// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Preact from "../bindings/Preact.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function ServedScreen(props) {
  let onTakeAnother = props.onTakeAnother;
  let twitterHandle = "@storename";
  let displayName = Stdlib_Option.getOr(props.storeName, "us");
  let handleTakeAnother = _e => {
    if (onTakeAnother !== undefined) {
      return onTakeAnother();
    }
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: "✓",
        className: "served-checkmark"
      }),
      JsxRuntime.jsx("h1", {
        children: "Thanks for visiting!",
        className: "served-title"
      }),
      JsxRuntime.jsx("p", {
        children: "We hope to see you again soon.",
        className: "served-message"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: `Follow ` + displayName
          }),
          JsxRuntime.jsx("p", {
            children: twitterHandle,
            className: "social-handle"
          }),
          JsxRuntime.jsx("a", {
            children: "🐦 Follow on Twitter",
            className: "social-link",
            "data-testid": "twitter-link",
            href: `https://twitter.com/` + twitterHandle.slice(1, 100),
            rel: "noopener noreferrer",
            target: "_blank"
          })
        ],
        className: "social-prompt",
        "data-testid": "social-prompt"
      }),
      JsxRuntime.jsx("button", {
        children: "Take Another Number",
        className: "btn btn-secondary",
        "data-testid": "take-another-btn",
        onClick: handleTakeAnother
      })
    ],
    className: "served-screen",
    "data-testid": "served-screen"
  });
}

function expose() {
  Preact.setWindowProperty("ServedScreen", ServedScreen);
}

let make = ServedScreen;

export {
  make,
  expose,
}
/* react/jsx-runtime Not a pure module */
